import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Col, UncontrolledTooltip } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { reverse } from 'named-urls';
import { dateToString } from '../../common/utils/date/Date.utils';
import { preparePriceFormat } from '../../helpers/preparePriceFormat';
import { formatOrganizationLocation } from '../../helpers/formatOrganizationLocation';
import editIcon from '../../assets/img/icons/edit-primary.svg';
import downloadIcon from '../../assets/img/icons/download.svg';
import { downloadInvoiceCreditNote, downloadInvoicePDF } from '../InvoicesActions';
import RouterPaths from '../../constants/RouterPaths';

function InvoicesTableRow({ item }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    id,
    serial,
    invoiceNumber,
    totalAmountInPence,
    createdOn,
    organizationName,
    organizationLocation,
    creditFacilityStatus,
    hasCreditNote,
  } = item;

  const handleInvoiceDownload = () => {
    if (id) {
      dispatch(downloadInvoicePDF(id));
    }
  };

  const handleCreditNoteDownload = () => {
    if (id) {
      dispatch(downloadInvoiceCreditNote(id));
    }
  };

  const handleEdit = () => {
    if (id) {
      navigate(reverse(RouterPaths.INVOICE_DETAIL, { id }));
    }
  };

  const prepareStatus = () => {
    if (hasCreditNote) return 'REFUNDED';
    return creditFacilityStatus ? creditFacilityStatus.replaceAll('_', ' ') : 'PAID';
  };

  return (
    <>
      <td className="fw-semibold">{serial ?? '-'}</td>
      <td>{invoiceNumber ?? '-'}</td>
      <td>{preparePriceFormat(totalAmountInPence, true) ?? '-'}</td>
      <td>{createdOn ? dateToString(createdOn) : '-'}</td>
      <td>{organizationName ?? '-'}</td>
      <td>{formatOrganizationLocation(organizationLocation) || '-'}</td>
      <td>{prepareStatus()}</td>
      <td className="invoices-table__action-cell text-right">
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip_edit${id}`}
          size="sm"
          type="button"
          onClick={handleEdit}
        >
          <img src={editIcon} alt="Edit icon" />
        </Button>
        <UncontrolledTooltip
          delay={0}
          className="uncontrolled-tooltip"
          target={`tooltip_edit${id}`}
        >
          Edit
        </UncontrolledTooltip>

        <div id={`tooltip_download${id}`} style={{ margin: '4px' }}>
          <Button
            className="btn-icon rounded-circle btn-ghost-light"
            size="sm"
            type="button"
            onClick={() => {
              if (hasCreditNote) return;
              handleInvoiceDownload();
            }}
          >
            <img src={downloadIcon} alt="Download icon" />
          </Button>
        </div>
        {hasCreditNote && (
          <UncontrolledTooltip
            delay={{ show: 100, hide: 100 }}
            autohide={false}
            innerClassName="m-0 p-0"
            className="transactions-table__invoice-tooltip"
            target={`tooltip_download${id}`}
          >
            <Col className="transactions-table__invoice-tooltip">
              <Col
                className="transactions-table__invoice-tooltip-btn cursor-pointer card-title btn-primary"
                onClick={() => {
                  handleInvoiceDownload(id);
                }}
              >
                Download invoice
              </Col>
              <Col
                className="transactions-table__invoice-tooltip-btn cursor-pointer card-title btn-primary"
                onClick={() => {
                  handleCreditNoteDownload(id);
                }}
              >
                Download credit note
              </Col>
            </Col>
          </UncontrolledTooltip>
        )}
      </td>
    </>
  );
}

InvoicesTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default InvoicesTableRow;
